function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1001 26.0113H3.66211L20.684 17.125H58.122L41.1001 26.0113Z",
  fill: "#F7CFC2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M75.3794 17.1257L58.303 0.0210476L3.58643 0L20.6839 17.1257H75.3794Z",
  fill: "#F2F2F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.3576 26.0113H3.66211L20.684 17.125H75.3795L58.3576 26.0113Z",
  fill: "#CCCCCC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M41.0457 0.0210476L37.7383 3.33394C36.7479 4.32598 35.4044 4.88304 34.0036 4.88304L0.939063 4.8662C0.123762 4.8662 -0.285289 3.87837 0.291865 3.30026L3.58669 0L41.0457 0.0210476Z",
  fill: "#F7CFC2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M58.3032 0.0210476L54.9958 3.33394C54.0054 4.32598 52.662 4.88304 51.2611 4.88304L0.939063 4.8662C0.123762 4.8662 -0.285289 3.87837 0.291865 3.30026L3.58669 0L58.3032 0.0210476Z",
  fill: "#CCCCCC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.684 17.125V26.0113H3.66211L20.684 17.125Z",
  fill: "#999999"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M58.3578 26.0113V60.3947L54.9985 63.9994H57.4556C58.0496 63.9994 58.6338 63.8563 59.1591 63.5813L74.8011 55.4148C75.1569 55.2296 75.3797 54.8606 75.3797 54.4592V17.125L58.3578 26.0113Z",
  fill: "#999999"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2946 43.3662L75.4849 31.041L75.4848 41.4183L59.5602 50.047C57.4131 51.2867 53.8976 51.656 52.6553 49.5042C51.4136 47.3536 52.1468 44.6046 54.2939 43.365L54.2946 43.3662Z",
  fill: "#0055FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3.66211 25.9863H58.3576V62.8688C58.3576 63.4932 57.8519 63.9997 57.2285 63.9997H4.73797C4.14401 63.9997 3.66211 63.517 3.66211 62.9221V25.9863Z",
  fill: "#F2F2F2"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6062 41.017H58.335V50.5909H18.6062C15.967 50.5909 13.8279 48.4482 13.8279 45.8032C13.8279 43.1597 15.967 41.0156 18.6062 41.0156V41.017Z",
  fill: "#0055FF"
});

function SvgPackG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref9), _ref10, _ref11);
}

var ForwardRef = React.forwardRef(SvgPackG);
export default __webpack_public_path__ + "static/media/pack-g.1662b8f1.svg";
export { ForwardRef as ReactComponent };